import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class PayrollDefinitionService {

  constructor(private http: HttpClient) { }

  getPayrollDefinitions() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/payroll_definition_list', OPTIONS);
  }

  getPayrollDefinitionType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/definition_type', OPTIONS);
  }

  getPayrollContract() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/payroll_contract', OPTIONS);
  }

  getPaymentRule() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/payment_rule', OPTIONS);
  }

  getWithholdingTax() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/withholding_tax', OPTIONS);
  }

  createUpdateDefinition(definitionInfo: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/save_update_definition', definitionInfo, OPTIONS);
  }

  deleteDefinition(definitionID: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_definition/${definitionID}`, OPTIONS);
  }

  deleteConcept(selectedIds: { conceptId: number }[]) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_concept`, selectedIds, OPTIONS);
  }

  deleteYearBatch(selectedIds: { yearId: number }[]) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_year_batch`, selectedIds, OPTIONS);
  }

  getPayrollConcept() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/payroll_concept', OPTIONS);
  }

  getMatrix() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/matrix', OPTIONS);
  }

  createUpdateConcept(conceptInfo: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/save_update_concept', conceptInfo, OPTIONS);
  }

  getYear() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_year', OPTIONS);
  }

  getComputationPeriod() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_computation_period', OPTIONS);
  }

  createUpdateYear(yearForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/save_update_year', yearForm, OPTIONS);
  }

  getYearList(HR_Payroll_ID: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `definition/get_year_list/${HR_Payroll_ID}`, OPTIONS);
  }

  deleteYear(yearId: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_year/${yearId}`, OPTIONS);
  }

  createPeriods(periodForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/create_period', periodForm, OPTIONS);
  }

  deletePeriod(selectedIds: { periodId: number }[]): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_period`, selectedIds, OPTIONS);
  }

  getDeductions() {
    return this.http.get<any>(Library.API_ENDPOINT + `definition/get_deduction_list`, OPTIONS);
  }

  createUpdateDeduction(deductionForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/save_update_deduction', deductionForm, OPTIONS);
  }

  deleteDeduction(deductionID: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_deduction/${deductionID}`, OPTIONS);
  }

  getAdjustments() {
    return this.http.get<any>(Library.API_ENDPOINT + `definition/get_adjustment_list`, OPTIONS);
  }

  createUpdateAdjustment(adjustmentForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/save_update_adjustment', adjustmentForm, OPTIONS);
  }

  deleteAdjustment(adjustmentID: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `definition/delete_adjustment/${adjustmentID}`, OPTIONS);
  }
}
